import { render } from "./SliderProductsNavigation.vue?vue&type=template&id=64bc4e6c&ts=true&lang=pug"
import script from "./SliderProductsNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./SliderProductsNavigation.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__